'use client';

import React, { type ReactNode } from 'react';
import { Box, Dialog, CloseButton, Flex, Text } from '@skin-seoul/design-system';
interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}
export const ModalHeader = ({
  title,
  onClose
}: ModalHeaderProps) => <Box paddingBottom={3} data-sentry-element="Box" data-sentry-component="ModalHeader" data-sentry-source-file="ModalContainer.tsx">
    <Flex justifyContent="space-between" alignItems="center" data-sentry-element="Flex" data-sentry-source-file="ModalContainer.tsx">
      <Text textStyle={{
      base: 'heading.h6.mobile',
      tablet: 'heading.h6'
    }} color="neutral.800" fontWeight="medium" data-sentry-element="Text" data-sentry-source-file="ModalContainer.tsx">
        {title}
      </Text>
      <CloseButton onClick={onClose} size="lg" variant="ghost" background="transparent" border="none" boxShadow="none" _focus={{
      boxShadow: 'none',
      outline: 'none',
      border: 'none'
    }} _focusVisible={{
      boxShadow: 'none'
    }} padding={0} height="22px" width="22px" marginRight={-3} data-sentry-element="CloseButton" data-sentry-source-file="ModalContainer.tsx" />
    </Flex>
  </Box>;
interface ModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export const ModalContainer = ({
  isOpen,
  onClose,
  title,
  children
}: ModalContainerProps) => {
  return <Dialog.Root open={isOpen} onOpenChange={({
    open
  }) => !open && onClose()} preventScroll data-sentry-element="Dialog.Root" data-sentry-component="ModalContainer" data-sentry-source-file="ModalContainer.tsx">
      <Dialog.Backdrop backgroundColor="black/20" backdropFilter="blur(2px)" data-sentry-element="Dialog.Backdrop" data-sentry-source-file="ModalContainer.tsx" />
      <Dialog.Positioner data-sentry-element="Dialog.Positioner" data-sentry-source-file="ModalContainer.tsx">
        <Dialog.Content maxWidth={{
        base: '100%',
        tablet: '600px'
      }} width="100%" minHeight={{
        base: `calc(100% - 103px)`,
        tablet: '80dvh'
      }} maxHeight={{
        base: `calc(100% - 103px)`,
        tablet: '80dvh'
      }} marginTop={{
        base: '39px',
        tablet: '10dvh'
      }} borderRadius={{
        base: 12,
        tablet: 16
      }} borderBottomRadius={{
        base: 0,
        tablet: 16
      }} padding={0} overflow="hidden" display="flex" flexDirection="column" data-sentry-element="Dialog.Content" data-sentry-source-file="ModalContainer.tsx">
          <Box background="white" paddingX={4} paddingTop={3} paddingBottom={0} flexShrink={0} data-sentry-element="Box" data-sentry-source-file="ModalContainer.tsx">
            <ModalHeader title={title} onClose={onClose} data-sentry-element="ModalHeader" data-sentry-source-file="ModalContainer.tsx" />
          </Box>
          <Box background="white" paddingX={4} paddingBottom={{
          base: 0,
          tablet: 3
        }} overflowY="auto" data-sentry-element="Box" data-sentry-source-file="ModalContainer.tsx">
            {children}
          </Box>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>;
};
export default ModalContainer;